<div class="flex flex-col">

  <div class="flex flex-row justify-center items-center" *ngIf="!isDriveForm">
    <particle-file-selector [(file)]="fileToUpload" class="flex flex-col  full-grow-no-shrink-no-basis "
                            [legend]="'Select a document for translation ( .PDF, .DOC, .XLS, .PPT)'"
                            [required]="true"
                            [acceptedTypes]="'.xlsx, .pdf, .doc, .docx, .xls,.ppt,.pptx'"
                            [showDriveOption]="!hasKPMGFeature"
                            (change)="handleFileInput()"
                            (dropChange)="handleFileInput()">
    </particle-file-selector>

  </div>
  <div *ngIf="!isAcceptedFileFormat && !isDriveForm" style="color:red" class="flex flex-row"><label>Invalid File
    Type(Accepted Format: PDF, DOC,
    XLS, PPT).</label><span>*</span></div>

  <!--//Masud vai told to do so-->
  <!--  <div class="notification-message-container m-0 m-t-10 m-b-20">

      <ul class="p-0 p-l-20">
        <li>You can upload Word, Excel or PDF documents for translation</li>
        <li>For best translation results, upload either a Word or Excel document</li>
        <li>Documents can be up to 60 pages for non-scanned and 15 pages for scanned</li>
        <li>Documents cannot exceed 5mb in file size</li>
        <li> You can translate up to 15 separate documents each day</li>
        <li> Check the Notifications menu to see the progress of your translation</li>
      </ul>
    </div>-->


  <div *ngIf="(fileToUpload || isDriveForm) && pdfSelected" class="m-t-15">
    <mat-checkbox [disabled]="isNotAForm" [(ngModel)]="isFileScanned" (change)="handleCheckbox()"
                  data-copilot="translation-checkbox-scanned">
      This is a scanned document
    </mat-checkbox>
  </div>

  <div class="m-t-15 flex flex-row justify-between items-center">
    <div class="flex flex-col" style="flex:0 0 48%">
      <mat-form-field appearance="outline" class="w-p-100" style="padding:2px ;">
        <mat-label>From Language *</mat-label>
        <mat-select placeholder="Select a Language" [(ngModel)]="fromLanguage" data-copilot="translation-select-from-language">
          <mat-option *ngFor="let language of translationSupportiveLanguage" [value]="language.code"
                      [attr.data-copilot]="'translation-option-from-' + language.code">
            {{language.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="flex flex-col" style="flex: 0 0 48%">
      <mat-form-field appearance="outline" class="w-p-100">
        <mat-label>To Language *</mat-label>
        <mat-select placeholder="Select a Language" [(ngModel)]="toLanguage" data-copilot="translation-select-to-language">
          <mat-option *ngFor="let language of translationSupportiveLanguage" [value]="language.code"
                      [attr.data-copilot]="'translation-option-to-' + language.code">
            {{language.name}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <div *ngIf="!isDriveForm" class="radio-buttons-section">
    <mat-form-field class="w-p-100" floatPlaceholder="always" floatLabel="always" appearance="outline">
      <mat-label>Storage *</mat-label>
      <input matInput placeholder="Input" style="display: none"
             particleAnalytics
             analyticsCategory="choice-filter-modal-item-editor"
             analyticsAction="entity-scope-input">
      <mat-radio-group [(ngModel)]="storageSettings">
        <mat-radio-button [disabled]="hasKPMGFeature" [value]="storageOptions.Stored" data-copilot="translation-radio-stored">
          <div class="flex flex-col">
            <span>
              I want to store this document in Orbitax
            </span>
            <div class="hint flex flex-col">
              Your document will be available to view, manage and share
              with your contacts via the Translation tool at any point.
            </div>
          </div>
        </mat-radio-button>
        <mat-radio-button [value]="storageOptions.NonStored" data-copilot="translation-radio-non-stored">
          <div class="flex flex-col">
          <span>
            I do not want to store this document in Orbitax
          </span>
            <div class="hint flex flex-col">

              <div *ngIf="hasKPMGFeature">
                Your document will be available to download for 15 minutes
                before being removed permanently from the system.
              </div>

              <div *ngIf="!hasKPMGFeature">
                Your document will be available to download for 24 hours
                before being removed permanently from the system.
              </div>
            </div>
          </div>
        </mat-radio-button>
      </mat-radio-group>
    </mat-form-field>
  </div>
</div>
